"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = require("../../../tokens");
var _interactive = require("../../../helpers/interactive");
var _Icon = require("../../Icon");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledClearButton = _styledComponents.default.button.withConfig({
  displayName: "StyledClearButton",
  componentId: "sc-1n5novn-0"
})(["pointer-events:all;padding:10px;margin:-10px;vertical-align:2px;line-height:0;border-radius:", ";", ""], _tokens.BORDER.RADIUS.S, _interactive.interactiveBoxShadowStyles);
const ClearButton = _ref => {
  let {
    onClear,
    inputRef,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(StyledClearButton, _extends({
    type: "button",
    "aria-label": "Clear",
    onClick: e => {
      if (typeof inputRef === 'object' && inputRef?.current) {
        inputRef.current.focus();
        if (onClear) {
          onClear(e);
        } else {
          inputRef.current.value = '';
        }
      }
    }
  }, props), /*#__PURE__*/_react.default.createElement(_Icon.CrossIcon, null));
};
exports.ClearButton = ClearButton;